// extracted by mini-css-extract-plugin
export default {"toggleButtons":"toggleButtons_toggleButtons__WaK3v"};